<template>
    <div  class="groupField_wrap mt20 mb20">
        <div class="chart" :class="customCss">
            <chart-header></chart-header>
            <template v-for="(elem, idx) in statistics">
                <div :key="idx" class="chartColumn">
                    <div class="chartHead">{{ getFormatDate(elem[0]) }} - {{ getFormatDate(elem[6]) }}</div>
                    <template v-for="chart in elem">
                        <div :key="chart.date" class="chartTd">
                            <div class="chartProgress">
                                <div
                                    @click="onStatisticsData(chart.date)"
                                    class="chartProgress-line"
                                    :style="`width: ${chart['repair']}%`"
                                >
                                    <div class="chartProgress-count">{{ chart['under_repair'] }}</div>
                                </div>
                                <div class="plan" :style="`left: ${chart['level_1']}%`"></div>
                                <div class="plan" :style="`left: ${chart['level_2']}%`"></div>
                                <div class="plan" :style="`left: ${chart['level_3']}%`"></div>
                            </div>
                            <div class="chartIcon">
                                <svg-sprite style="color: #e91e63" width="20" height="20" :icon-id="`st_${chart['status']}`"></svg-sprite>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
// components
import ChartHeader from "@/components/Fleet/WorkOrdersStatistics/StatisticsChart/ChartHeader/ChartHeader";
// helper
import { formatDate } from "@/helper";

export default {
	name: "StatisticsChart",
	components: {
		ChartHeader
	},
	props: {
		statistics: Array,
		customCss: String
	},
	methods: {
		getFormatDate({ date }) {
			return formatDate(date);
		},
		onStatisticsData(date) {
			this.$emit('updateStatisticsData', date);
		}
	}
};
</script>

<style scoped lang="scss">
@import "statisticsChart";
</style>
